var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5959_27253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#001145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4061 5.6842H14.473C14.7035 7.40841 15.5782 8.50105 17.4098 8.65578V10.6626C16.3393 10.781 15.4219 10.3579 14.5046 9.81789C14.5046 9.90631 14.5314 12.6474 14.4856 13.9547C14.4398 15.2984 13.9598 16.481 12.9067 17.3637C10.674 19.2379 7.50509 18.2258 6.74877 15.36C6.33824 13.7984 6.69509 12.3916 7.92035 11.2784C8.61035 10.6468 9.4614 10.3658 10.374 10.2489C10.5698 10.2237 10.7672 10.2126 10.9788 10.1937V12.3158C10.7103 12.3821 10.4388 12.4405 10.1719 12.5195C9.98681 12.5729 9.80624 12.641 9.63193 12.7232C9.38875 12.8325 9.17401 12.9964 9.00436 13.2021C8.83471 13.4078 8.7147 13.6498 8.65363 13.9094C8.59256 14.1689 8.59207 14.4391 8.65219 14.6988C8.71232 14.9586 8.83145 15.201 9.00035 15.4074C9.20345 15.6882 9.4797 15.9079 9.79902 16.0427C10.1183 16.1774 10.4685 16.222 10.8114 16.1716C11.5014 16.0879 11.934 15.6537 12.1898 15.03C12.3667 14.5364 12.4434 14.0125 12.4156 13.4889C12.4061 10.9121 12.4061 8.33684 12.4014 5.75999C12.4016 5.73466 12.4032 5.70936 12.4061 5.6842Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5959_27253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.7f23ed8152a4b892dd19d16ba0679247.svg";
export { ForwardRef as ReactComponent };